function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", summary.parentNode.hasAttribute("open"));

  if (summary.nextElementSibling) {
    if (summary.nextElementSibling.getAttribute("id")) {
      summary.setAttribute("aria-controls", summary.nextElementSibling.id);
    }
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*");
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      if (buttonMinus) {
        buttonMinus.classList.toggle("disabled", value <= min);
      }
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      if (buttonPlus) {
        buttonPlus.classList.toggle("disabled", value >= max);
      }
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options["hideElement"] || province_domid);

  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector("button"));
      summaryElement.nextElementSibling.removeEventListener("transitionend", addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener("transitionend", addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((submenu) => {
      submenu.classList.remove("submenu-open");
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement.querySelector("summary").setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(detailsElement.closest("details[open]"), detailsElement.querySelector("summary"));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.documentElement.classList.add('menu-open');
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    document.documentElement.classList.remove('menu-open');
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this, false));
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (event.pointerType === "mouse" && !event.target.closest("deferred-media, product-model")) this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    window.pauseAllMedia();
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const closeButton = this.querySelector('[id^="ModalClose-"]');
        trapFocus(this, closeButton || this.querySelector('[role="dialog"]'));
      });
    });
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(content.querySelector("video, model-viewer, iframe"));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.horizontalSliderItemOffset = this.sliderItemsToShow[1].offsetTop - this.sliderItemsToShow[0].offsetTop;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollTop === 0 &&
      this.slider.parentElement.classList.contains("product__media-list-container")
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    if (this.slider.parentElement.classList.contains("product__media-list-container")) {
      const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollTop - offset;
      return element.offsetTop + element.clientWidth <= lastVisibleSlide && element.offsetTop >= this.slider.scrollTop;
    } else {
      const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
      return (
        element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft
      );
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    if (this.slider.parentElement.classList.contains("product__media-list-container")) {
      this.slideScrollPosition =
        event.currentTarget.name === "next"
          ? this.slider.scrollTop + step * this.horizontalSliderItemOffset
          : this.slider.scrollTop - step * this.horizontalSliderItemOffset;
      this.slider.scrollTo({
        top: this.slideScrollPosition,
      });
    } else {
      this.slideScrollPosition =
        event.currentTarget.name === "next"
          ? this.slider.scrollLeft + step * this.sliderItemOffset
          : this.slider.scrollLeft - step * this.sliderItemOffset;
      this.slider.scrollTo({
        left: this.slideScrollPosition,
      });
    }
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();

    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.sliderContentButtons = this.querySelectorAll(".banner__buttons a");
    this.sliderSlideLinks = this.querySelectorAll(".slideshow__slide > a");
    this.enableSliderLooping = true;
    this.gTagControlsData = {
      page_location: window.location.href,
      slide_number: this.currentPage,
    };
    this.gtagSlideshowData = {
      click_text: "",
      click_url: "",
      page_location: window.location.href,
      slide_number: this.currentPage,
    };

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll(".slider-counter__link"));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener("click", this.linkToSlide.bind(this)));
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();
    window.addEventListener("resize", () => {
      if (this.slider.getAttribute("data-autoplay") === "true" && !this.isMobile()) {
        this.setAutoPlay();
      }

      if (this.slider.getAttribute("data-autoplay") === "true" && this.isMobile()) {
        this.destroyAutoPlay();
      }
    });

    window.dispatchEvent(new Event("resize"));

    this.sliderContentButtons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        this.gtagSlideshowData.click_url = e.target.href;
        this.gtagSlideshowData.click_text = e.target.textContent;
        this.gtagSlideshowData.slide_number = this.currentPage;

        gtag("event", "slideshow_button_click", this.gtagSlideshowData);
      });
    });

    this.sliderSlideLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        this.gtagSlideshowData.click_url = e.target?.href;
        this.gtagSlideshowData.slide_number = this.currentPage;

        gtag("event", "slideshow_click", this.gtagSlideshowData);
      });
    });
  }

  isMobile() {
    return window.innerWidth <= 749;
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.sliderItems[this.currentPage - 1].dataset.speed * 1000;
    this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this));
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));
    this.addEventListener("mouseover", this.pause.bind(this));
    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  destroyAutoPlay() {
    this.removeEventListener("mouseover", this.focusInHandling.bind(this));
    this.removeEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.removeEventListener("focusin", this.focusInHandling.bind(this));
    this.removeEventListener("focusout", this.focusOutHandling.bind(this));
    this.removeEventListener("mouseover", this.pause.bind(this));
    this.pause();
    this.autoplayButtonIsSetToPlay = false;
  }

  onButtonClick(event) {
    super.onButtonClick(event);

    this.gTagControlsData.slide_number = this.currentPage;

    if (event.currentTarget.name === "next") {
      gtag("event", "slideshow_next", this.gTagControlsData);
    }

    if (event.currentTarget.name === "prev") {
      gtag("event", "slideshow_previous", this.gTagControlsData);
    }

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add("slider-counter__link--active");
    this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    this.pause();
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });

    this.autoplaySpeed =
      this.sliderItems[this.currentPage === this.sliderItems.length ? 0 : this.currentPage].dataset.speed * 1000;

    this.play();
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);

    this.slider.scrollTo({
      left: slideScrollPosition,
    });

    this.gTagControlsData.slide_number = this.sliderControlLinksArray.indexOf(event.currentTarget) + 1;
    gtag("event", "slideshow_nav", this.gTagControlsData);
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this.setSwatchDropdownTriggerText();
    this.setSelectAnOption();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateNotificationBanner();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateNotificationBanner() {
    if (window.klaviyoBIS) {
      const existingNotification = document.getElementById('noti-button');
      if (existingNotification) {
        existingNotification.remove();
      }

      if (this.currentVariant.available == false) {
        const dropdownSelector = document.querySelector('[id^="variant-selects-template"]');
        const notificationBanner = document.createElement('div');
        notificationBanner.innerHTML = "<div class='button-group' id='noti-button'>" + 
            "<a class='klaviyo-bis-trigger button w100 large' href='#'>Notify Me When Available</a>" +
            "</div>";
        dropdownSelector.insertAdjacentElement('afterend', notificationBanner);
      }
    }
  }

  setSelectAnOption() {
    const addToCartButtons = document.querySelectorAll(".product-form__submit");
    const variants = this.querySelectorAll("select");
    variants.forEach((variant) => {
      const variantOptions = [...variant.options];
      variantOptions.forEach((option) => {
        if (option.selected && option.classList.contains("disabled-option")) {
          addToCartButtons.forEach((btn) => (btn.disabled = true));
        }
      });
    });
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll("select"), (select) => select.value);
  }

  updatePrice() {
    const priceLast2Charts = this.currentVariant.price.toString().slice(-2);
    let price;
    let newPrice;

    if (this.currentVariant.compare_at_price) {
      const newPriceLast2Charts = this.currentVariant.compare_at_price.toString().slice(-2);
      newPrice = "$" + (this.currentVariant.compare_at_price / 100).toString() + "." + newPriceLast2Charts;
      price = "$" + (this.currentVariant.price / 100).toString();
    } else {
      price = "$" + (this.currentVariant.price / 100).toString() + "." + priceLast2Charts;
    }
    const priceContainer = `
      <div class="price-container">
    <div class="price ${this.currentVariant.compare_at_price !== null ? `price-sale` : ``}">
      ${price}
    </div>
    <div class="price-old ${this.currentVariant.compare_at_price === null ? `hide` : ``}">
      ${newPrice}
    </div>
  </div>
</div>
      `;
    if (document.querySelector(".cloned-price")) {
      document.querySelector(".cloned-price").innerHTML = "";
      document
        .querySelector(".cloned-price")
        .appendChild(document.createRange().createContextualFragment(priceContainer));
    }
  }

  setSwatchDropdownTriggerText() {
    const dropdownTriggers = [...document.querySelectorAll(".swatch-dropdown-trigger")];
    const dropdownsNames = [...document.querySelectorAll(".swatch-dropdown")];
    const inputs = [...document.querySelectorAll("fieldset .option-element input[type=radio]:checked")];
    const variantsSelects = document.querySelector("variant-selects");
    const hiddenStickySwatchInputs = [...document.querySelectorAll("#stickySwatches input")];

    if (inputs.length > 0) {
      for (let i = 0; i < dropdownTriggers.length; i++) {
        dropdownTriggers[i].textContent = dropdownsNames[i].dataset.dropdownName + " " + inputs[i]?.value;

        hiddenStickySwatchInputs[i].value = inputs[i]?.value;
      }
    } else {
      dropdownTriggers.map((trigger) => {
        const variantName = trigger.parentElement.getAttribute("data-dropdown-name");
        const variantSelect = variantsSelects.querySelector("select[name='options[" + variantName + "]']");

        if (variantName === trigger.parentElement.getAttribute("data-dropdown-name")) {
          if (variantSelect.value) {
            trigger.textContent = variantName + " " + variantSelect.value;
            hiddenStickySwatchInputs.map((input) => {
              if (input.name === variantName) {
                input.value = variantSelect.value;
              }
            });
          }
        }
      });
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    if (this.currentVariant) {
      this.updatePrice();
      this.setSwatchDropdownTriggerText();
    }

    if (window.Klarna && window.Klarna.OnsiteMessaging && this.currentVariant) {
      document.querySelectorAll("klarna-placement").forEach((element) => {
        element.setAttribute("data-purchase_amount", this.currentVariant.price);
      });
      window.Klarna.OnsiteMessaging = window.Klarna.OnsiteMessaging || [];
      window.Klarna.OnsiteMessaging.refresh();
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true),
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-${this.dataset.section}-sticky`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1,
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        if (!input.classList.contains("disabled-option")) {
          input.innerText = window.variantStrings.unavailable_with_option.replace(
            "[value]",
            input.getAttribute("value"),
          );
        }
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const priceWrappers = document.querySelectorAll(`#price-${this.dataset.section}`);

        const priceSource = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );

        if (priceWrappers && priceWrappers.length > 0 && priceSource) {
          Array.from(priceWrappers).forEach((item) => {
            item.innerHTML = priceSource.innerHTML;
          });
        }

        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle("visibility-hidden", skuSource.classList.contains("visibility-hidden"));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle("visibility-hidden", inventorySource.innerText === "");

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut,
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const stickyProductForm = document.getElementById(`product-form-${this.dataset.section}-sticky`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const stickyAddButton = stickyProductForm?.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const stickyAddButtonText = stickyProductForm?.querySelector('[name="add"]');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");

      if (stickyAddButton) {
        stickyAddButton.setAttribute("disabled", "disabled");
        if (text) stickyAddButtonText.textContent = text;
      }

      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      if (addButton.classList.contains('presale')) {
        addButtonText.textContent = 'Pre-Order';
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }

      if (stickyAddButton) {
        stickyAddButton.removeAttribute("disabled");
        stickyAddButton.textContent = window.variantStrings.addToCart;
        stickyAddButton.innerHTML += 
          "<div class='loading-overlay__spinner hidden'>" + 
          "<svg aria-hidden='true' focusable='false' class='spinner' viewBox='0 0 66 66' xmlns='http://www.w3.org/2000/svg'>" +
          "<circle class='path' fill='none' stroke-width='6' cx='33' cy='33' r='30'></circle></svg></div>";
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const stickyButton = document.getElementById(`product-form-${this.dataset.section}-sticky`);

    const addButton = button.querySelector('[name="add"]');
    const stickyAddButton = stickyButton.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const stickyAddButtonText = stickyButton.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;

    if (stickyAddButton) {
      if (stickyAddButtonText) {
        stickyAddButtonText.textContent = window.variantStrings.unavailable;
      } else {
        stickyAddButton.textContent = window.variantStrings.unavailable;
      }
    }

    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector("slideshow-component") && this.classList.contains("complementary-products")) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class DataLayerEvents {
  constructor(email) {
    this.customerEmail = email;
  }
  setLogoutBtnClick() {
    document.querySelector("#log-out-btn").addEventListener("click", function () {
      localStorage.removeItem("loginEvent");
      localStorage.removeItem("newsletterSignupEvent");
      localStorage.removeItem("registerEvent");
    });
  }
  setSignInBtnClick() {
    document.querySelector("#sign-in-btn").addEventListener("click", function () {
      localStorage.setItem("loginEvent", "1");
    });
  }
  setCreateAccountBtnClick() {
    document.querySelector("#create-account-btn").addEventListener("click", function () {
      if (document.getElementById("newsletter").value === "on") {
        localStorage.setItem("newsletterSignupEvent", "1");
      }
      localStorage.setItem("loginEvent", "1");
      localStorage.setItem("registerEvent", "1");
    });
  }
  setNewsletterSignUpBtnClick() {
    document.querySelector("form button").addEventListener("click", function () {
      this.pushDataLayerEvent("newsletterSignup");
    });
  }
  pushDataLayerEvent(event) {
    // eslint-disable-next-line no-undef
    dataLayer.push({
      event: event,
      customer_details: {
        email: this.customerEmail,
        // eslint-disable-next-line no-undef
        email_sha256: CryptoJS.SHA256(this.customerEmail).toString(),
      },
    });
  }
}

window.DataLayerEvents = new DataLayerEvents();

const formatMoney = (cents, format) => {
  const moneyFormat = "${{amount}}";
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || moneyFormat;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

const cartPage = () => {
  let CART = null;
  const shoppingCartPipUpdate = function () {
    let cartQuant = CART.item_count;
    if (cartQuant > 0) {
      const cartPip = document.querySelector("#cart-pip");
      if (cartPip) {
        cartPip.textContent = cartQuant;
      }
    }
  };

  const updateCartObj = async function (reload) {
    try {
      const res = await fetch("/cart.js");

      if (res.ok) {
        const data = await res.json();
        CART = data;
        let totalCart = `${CART.currency} ${formatMoney(CART.total_price, "{{amount}}")}`;
        const totalCartPriceEl = document.querySelector(".total-cart-price");

        if (totalCartPriceEl) {
          totalCartPriceEl.innerHTML = totalCart;
        }

        shoppingCartPipUpdate();

        if (reload === true) {
          setTimeout(() => {
            window.location.reload(true);
          }, 150);
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  let timer;
  const updateAddToCart = function () {
    const addToCartBtn = document.querySelector("#product-addtocart");

    if (addToCartBtn) {
      addToCartBtn.disabled = "disabled";
      addToCartBtn.value = window.productStrings.itemAdded || "Item Added";
    }

    clearTimeout(timer);
    timer = setTimeout(function () {
      if (document.querySelectorAll(".only-item-pdp")[0]) {
        addToCartBtn.disabled = false;
        addToCartBtn.value = window.productStrings.addToCart || "Add To Cart";

        document.querySelector(".actions-wrapper").style.display = "none";
        document.querySelector(".product-notice").style.display = "none";
        document.querySelector(".swatch").style.display = "none";
        document.querySelector(".swatch-dropdown").style.display = "none";
        document.querySelector(".product-notice-only-item").display = "block";
        document.querySelector(".cloned-empty-cart-actions").style.display = "block";
        const actions = document.querySelector(".pdp-actions");
        const html = `<div class="empty-cart-actions">
          <div class="button-group">
            <input class="button primary w100 empty-cart" type="submit" value="Empty cart"/>
          </div>
        </div>`;

        actions.innerHTML += html;
        addToCartBtn.disabled = false;
        addToCartBtn.value = addToCartBtn.classList.contains("presale")
          ? "pre-order"
          : window.productStrings.addToCart || "Add To Cart";
        document.querySelector("body").classList.remove("add-to-cart-loading");
      }
    }, 5000);
  };

  const ajaxAddToCart = document.querySelector(".ajax-add-to-cart");

  if (ajaxAddToCart) {
    ajaxAddToCart.addEventListener("click", async function (e) {
      e.preventDefault();
      window.dispatchEvent(new Event("add-to-cart-click"));

      let productID = document.querySelector("#ProductSelect option:checked").value,
        productQuant = document.querySelector("#Quantity").value;
      if (productID === undefined) {
        productID = document.querySelector("#ProductSelect").value;
      }

      document.querySelector("body").classList.add("add-to-cart-loading");

      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            quantity: productQuant,
            id: productID,
          }),
        });

        if (res.ok) {
          updateCartObj();
          updateAddToCart();

          await res.json();
          window.dispatchEvent(new Event("product-added"));
        } else {
          window.dispatchEvent(new Event("product-add-error"));
        }
      } catch (e) {
        console.error(e);
        window.dispatchEvent(new Event("product-add-error"));
      }
    });
  }

  // cart page - update cart on change of items quantity
  document.querySelectorAll("[data-update-cart]").forEach((btn) => {
    btn.addEventListener("click", async function (e) {
      e.preventDefault();
      let data = {};
      data.updates = {};

      document.querySelectorAll('input[type="number"].quantity').forEach((input) => {
        let id = input.dataset.itemid;
        let quantity = parseInt(input.value);
        data.updates[id] = quantity;
      });

      try {
        const res = await fetch("/cart/update.js", {
          headers: {
            "Content-Type": "application/json",
          },
          method: "POST",
          body: JSON.stringify(data),
        });

        if (res.ok) {
          await res.json();
          updateCartObj(true);
        }
      } catch (e) {
        console.error("Something went wrong", e);
      }
    });
  });

  document.querySelectorAll(".remove-item-cart").forEach((item) => {
    item.addEventListener("click", async function (e) {
      e.preventDefault();
      const itemId = this.dataset.itemid;

      try {
        const res = await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            quantity: 0,
            id: itemId,
          }),
        });

        if (res.ok) {
          updateCartObj(true);
        }
      } catch (e) {
        console.error(e);
      }
    });
  });

  // fires off all the things that require an updated cart object
  updateCartObj();

  document.querySelectorAll(".quantity").forEach((input) => {
    input.addEventListener("change", function () {
      if (this.value > 25) {
        this.value = 25;
      }

      const itemId = this.dataset.itemid;
      const qty = this.value;
      const cartItems = CART.items;
      const originalPrice = document.querySelectorAll(
        `#checkout-table td:not(.total) .grid-original-price[data-itemid='${itemId}']`,
      );
      const salePrice = document.querySelectorAll(`#checkout-table .total .grid-price-sale[data-itemid='${itemId}']`);

      const showUpdatedPrice = (elements, id) => {
        elements.forEach((element, i) => {
          const itemObj = cartItems.find((item) => item.id.toString() === itemId);

          const cachedOriginalPrice =
            element === originalPrice[i] && element.dataset.price ? element.dataset.price : null;

          const cachedSalePrice = itemObj.final_price;
          const updatedSalePriceVal = qty * cachedSalePrice;
          let updatedOriginalPriceVal = null;

          const originalToUpdateElms = document.querySelectorAll(
            `#checkout-table .total .grid-original-price[data-itemid='${id}']`,
          );

          const originalPriceString = originalToUpdateElms[0].textContent.trim();

          const currencySymbolPlacement = originalPriceString.indexOf(window.currencySymbol);
          const formatMoneyString =
            currencySymbolPlacement <= 0
              ? `${window.currencySymbol}{{amount_with_comma_separator}}`
              : `{{amount_with_comma_separator}} ${window.currencySymbol}`;

          if (cachedOriginalPrice) {
            updatedOriginalPriceVal = qty * cachedOriginalPrice;
          }

          if (element === originalPrice[i] && cachedOriginalPrice) {
            originalToUpdateElms.forEach((el) => {
              el.textContent = formatMoney(updatedOriginalPriceVal, formatMoneyString);
            });
          } else if (salePrice.length > 0) {
            salePrice.forEach((sale) => {
              sale.textContent = formatMoney(updatedSalePriceVal, formatMoneyString);
            });
          }

          const originalQty = itemObj.quantity;

          if (originalQty !== parseInt(qty)) {
            this.closest("tr").classList.add("updated");
          } else {
            this.closest("tr").classList.remove("updated");
          }
        });
      };

      showUpdatedPrice(originalPrice, itemId);
      showUpdatedPrice(salePrice, itemId);
    });
  });

  let orderSummarySticky = document.querySelector(".order-summary-sticky"),
    orderSummaryStatic = document.querySelector(".order-summary:not(.order-summary-sticky)"),
    windowWidth = window.innerWidth;

  function isInViewport(el) {
    if (orderSummarySticky) {
      if (windowWidth < 1024) {
        if (el) {
          let elementTop = el.getBoundingClientRect().top + window.scrollY,
            scrollTop = document.documentElement.scrollTop,
            viewportBottom = scrollTop + window.innerHeight,
            elementBottom = elementTop + el.clientHeight;

          setTimeout(function () {
            if (document.querySelectorAll(".order-summary-sticky .additional-checkout-buttons").length === 0) {
              const additionalCheckoutBtns = document.querySelector(".additional-checkout-buttons").cloneNode(true);
              const orderSummarySticky = document.querySelector(".order-summary-sticky .button-container");
              orderSummarySticky.appendChild(additionalCheckoutBtns);
            }
          }, 2500);

          if (elementBottom - 100 > scrollTop && elementTop < viewportBottom) {
            orderSummarySticky.classList.remove("sticky");
          } else {
            orderSummarySticky.classList.add("sticky");
          }
        }
      } else {
        orderSummarySticky.classList.remove("sticky");
      }
    }
  }

  window.addEventListener("resize", () => isInViewport(orderSummaryStatic));
  window.addEventListener("scroll", () => isInViewport(orderSummaryStatic));
  window.addEventListener("load", () => isInViewport(orderSummaryStatic));
};

cartPage();
